import React, { useEffect, useState } from "react";
import "../../css/ProfileDetail.css";
import ProfileSidebar from "../profile/ProfileSidebar";
import MyTransactions from "../profile/MyTransactions";
import MyMessages from "../profile/MyMessages";
import ManagePlan from "../profile/ManagePlan";
import ProfileDetails from "../profile/ProfileDetails";
import ProfileEdit from "../profile/ProfileEdit";
import MyReviews from "../profile/MyReviews";
import ContactProperty from "../property/ContactProperty";
import ShortlistProperty from "../property/ShortlistProperty";
import ViewProperty from "../property/ViewProperty";
import { useLocation } from "react-router-dom";
import { eventEmitter } from "../EventEmitter";
import Advertisement from "../Advertisement";
import MyProjects from "./MyProjects";
import MyListings from "./MyListings";
import MyPropertyValuation from "./MyPropertyValuation";
import MyEnquiry from "./MyEnquiry";
const MyProfile = () => {
  const [selectedSection, setSelectedSection] = useState("myProfile");
  const handleSelection = (value) => {
    if (value !== selectedSection) {
      setSelectedSection(value);
      // alert('handle');
    }
  };
  const renderSection = () => {
    switch (selectedSection) {
      case "myProfile":
        return <ProfileDetails handleSelection={handleSelection} />;
      case "myTransactions":
        return <MyTransactions />;
      case "myMessages":
        return <MyMessages />;
      case "mySubscription":
        return <ManagePlan />;
      case "profileEdit":
        return <ProfileEdit />;
      case "myReviews":
        return <MyReviews />;
      case "contactedProperty":
        return <ContactProperty />;
      case "shortlistProperty":
        return <ShortlistProperty />;
      case "viewProperty":
        return <ViewProperty />;
      case "myProjects":
        return <MyProjects />;
      case "myListings":
        return <MyListings />;
      case "MyPropertyValuation":
        return <MyPropertyValuation />;
      case "myEnquiry":
        return <MyEnquiry />;
    }
  };
  useEffect(() => {
    const handleEvent = (msg) => {
      setSelectedSection(msg);
    };

    eventEmitter.on("customEvent", handleEvent);

    return () => {
      eventEmitter.off("customEvent", handleEvent); // Clean up the event listener
    };
  }, []);
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const section = params.get("value") || selectedSection; // Default to "myProfile" if null

    if (section !== selectedSection) {
      setSelectedSection(section);
    }

    // Update URL to include default if missing
    // if (!params.has("value")) {
    //     window.history.replaceState({}, "", `/myProfile?value=${section}`);
    // }
  }, [location.search]);
  useEffect(() => {
    window.history.pushState({}, "", `/myProfile?value=${selectedSection}`);
  }, [selectedSection]);

  return (
    <>
      <div className="myprofouterbox d-flex mt-5 mb-5">
        <div className="myprofsidebox">
          <ProfileSidebar handleSelection={handleSelection} />
        </div>
        <div className="middleDiv ">{renderSection()}</div>

        <div className="adsidebarbx desk">
          <Advertisement />
        </div>
      </div>
    </>
  );
};

export default MyProfile;
